export default {
  PostLogin: process.env.VUE_APP_LOGIN_API_URL,
  PostCreateBeneficiary: process.env.VUE_APP_CREATE_BENEFICIARY_API_URL,
  GetDataBeneficiary: process.env.VUE_APP_PERSONAL_INFORMATION_URL,
  PostRecoveryPassword: process.env.VUE_APP_RECOVERY_PASSWORD_URL,
  GetValidateBeneficiary: process.env.VUE_APP_VALIDATE_BENEFICIARY_URL,
  GetVerifyBeneficiary: process.env.VUE_APP_VERIFY_BENEFICIARY_URL,
  GetVerifyCI: process.env.VUE_APP_VERIFY_CI,
  GetVerifyBeneficiaryEmail: process.env.VUE_APP_VERIFY_BENEFICIARY_SEND_EMAIL_URL,
};

export const MESSAGE_ERROR_LOGIN = {
  201: 'timeOver',
  203: 'notFound',
  204: 'notMatch',
  500: 'errorGeneric',
};
